/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime';
import { BuildingFromJSON, FloorFromJSON, FloorPagedCollectionApiResponseFromJSON, RoomFromJSON, RoomPagedCollectionApiResponseFromJSON, } from '../models';
/**
 *
 */
var BuildingsApi = /** @class */ (function (_super) {
    __extends(BuildingsApi, _super);
    function BuildingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     */
    BuildingsApi.prototype.getFloorsByBuildingCodeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.buildingCode !== undefined) {
                            queryParameters['buildingCode'] = requestParameters.buildingCode;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Buildings/buildingcode/floors",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(FloorFromJSON); })];
                }
            });
        });
    };
    /**
     */
    BuildingsApi.prototype.getFloorsByBuildingCode = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getFloorsByBuildingCodeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BuildingsApi.prototype.getFloorsByBuildingIdRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (requestParameters.buildingId === null || requestParameters.buildingId === undefined) {
                            throw new runtime.RequiredError('buildingId', 'Required parameter requestParameters.buildingId was null or undefined when calling getFloorsByBuildingId.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Buildings/{buildingId}/floors".replace("{" + "buildingId" + "}", encodeURIComponent(String(requestParameters.buildingId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(FloorFromJSON); })];
                }
            });
        });
    };
    /**
     */
    BuildingsApi.prototype.getFloorsByBuildingId = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getFloorsByBuildingIdRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BuildingsApi.prototype.getRoomsByBuildingCodeAndFloorCodeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.buildingCode !== undefined) {
                            queryParameters['buildingCode'] = requestParameters.buildingCode;
                        }
                        if (requestParameters.floorCode !== undefined) {
                            queryParameters['floorCode'] = requestParameters.floorCode;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Buildings/floors/rooms",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(RoomFromJSON); })];
                }
            });
        });
    };
    /**
     */
    BuildingsApi.prototype.getRoomsByBuildingCodeAndFloorCode = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRoomsByBuildingCodeAndFloorCodeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BuildingsApi.prototype.queryBuildingsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.skip !== undefined) {
                            queryParameters['Skip'] = requestParameters.skip;
                        }
                        if (requestParameters.take !== undefined) {
                            queryParameters['Take'] = requestParameters.take;
                        }
                        if (requestParameters.fMRecordId !== undefined) {
                            queryParameters['FMRecordId'] = requestParameters.fMRecordId;
                        }
                        if (requestParameters.fMModId !== undefined) {
                            queryParameters['FMModId'] = requestParameters.fMModId;
                        }
                        if (requestParameters.buildingId !== undefined) {
                            queryParameters['BuildingId'] = requestParameters.buildingId;
                        }
                        if (requestParameters.propertyId !== undefined) {
                            queryParameters['PropertyId'] = requestParameters.propertyId;
                        }
                        if (requestParameters.campus !== undefined) {
                            queryParameters['Campus'] = requestParameters.campus;
                        }
                        if (requestParameters.buildingCode !== undefined) {
                            queryParameters['BuildingCode'] = requestParameters.buildingCode;
                        }
                        if (requestParameters.buildingName !== undefined) {
                            queryParameters['BuildingName'] = requestParameters.buildingName;
                        }
                        if (requestParameters.buildingNameAlt !== undefined) {
                            queryParameters['BuildingNameAlt'] = requestParameters.buildingNameAlt;
                        }
                        if (requestParameters.category !== undefined) {
                            queryParameters['Category'] = requestParameters.category;
                        }
                        if (requestParameters.address !== undefined) {
                            queryParameters['Address'] = requestParameters.address;
                        }
                        if (requestParameters.city !== undefined) {
                            queryParameters['City'] = requestParameters.city;
                        }
                        if (requestParameters.state !== undefined) {
                            queryParameters['State'] = requestParameters.state;
                        }
                        if (requestParameters.zip !== undefined) {
                            queryParameters['Zip'] = requestParameters.zip;
                        }
                        if (requestParameters.country !== undefined) {
                            queryParameters['Country'] = requestParameters.country;
                        }
                        if (requestParameters.contactName !== undefined) {
                            queryParameters['ContactName'] = requestParameters.contactName;
                        }
                        if (requestParameters.accountCode1 !== undefined) {
                            queryParameters['AccountCode1'] = requestParameters.accountCode1;
                        }
                        if (requestParameters.accountCode2 !== undefined) {
                            queryParameters['AccountCode2'] = requestParameters.accountCode2;
                        }
                        if (requestParameters.accountCode3 !== undefined) {
                            queryParameters['AccountCode3'] = requestParameters.accountCode3;
                        }
                        if (requestParameters.jobTypes !== undefined) {
                            queryParameters['JobTypes'] = requestParameters.jobTypes;
                        }
                        if (requestParameters.notes !== undefined) {
                            queryParameters['Notes'] = requestParameters.notes;
                        }
                        if (requestParameters.buildingPhotoData !== undefined) {
                            queryParameters['BuildingPhotoData'] = requestParameters.buildingPhotoData;
                        }
                        if (requestParameters.detail !== undefined) {
                            queryParameters['Detail'] = requestParameters.detail;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Buildings",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(BuildingFromJSON); })];
                }
            });
        });
    };
    /**
     */
    BuildingsApi.prototype.queryBuildings = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryBuildingsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BuildingsApi.prototype.queryFloorsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.sortColumn !== undefined) {
                            queryParameters['SortColumn'] = requestParameters.sortColumn;
                        }
                        if (requestParameters.sortDirection !== undefined) {
                            queryParameters['SortDirection'] = requestParameters.sortDirection;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['Skip'] = requestParameters.skip;
                        }
                        if (requestParameters.take !== undefined) {
                            queryParameters['Take'] = requestParameters.take;
                        }
                        if (requestParameters.fMRecordId !== undefined) {
                            queryParameters['FMRecordId'] = requestParameters.fMRecordId;
                        }
                        if (requestParameters.fMModId !== undefined) {
                            queryParameters['FMModId'] = requestParameters.fMModId;
                        }
                        if (requestParameters.floorId !== undefined) {
                            queryParameters['FloorId'] = requestParameters.floorId;
                        }
                        if (requestParameters.buildingId !== undefined) {
                            queryParameters['BuildingId'] = requestParameters.buildingId;
                        }
                        if (requestParameters.propertyId !== undefined) {
                            queryParameters['PropertyId'] = requestParameters.propertyId;
                        }
                        if (requestParameters.floorCode !== undefined) {
                            queryParameters['FloorCode'] = requestParameters.floorCode;
                        }
                        if (requestParameters.floorName !== undefined) {
                            queryParameters['FloorName'] = requestParameters.floorName;
                        }
                        if (requestParameters.floorSortNum !== undefined) {
                            queryParameters['FloorSortNum'] = requestParameters.floorSortNum;
                        }
                        if (requestParameters.notes !== undefined) {
                            queryParameters['Notes'] = requestParameters.notes;
                        }
                        if (requestParameters.floorplanFilenameSimple !== undefined) {
                            queryParameters['FloorplanFilenameSimple'] = requestParameters.floorplanFilenameSimple;
                        }
                        if (requestParameters.floorplanFilenameFull !== undefined) {
                            queryParameters['FloorplanFilenameFull'] = requestParameters.floorplanFilenameFull;
                        }
                        if (requestParameters.coordinateNorth !== undefined) {
                            queryParameters['CoordinateNorth'] = requestParameters.coordinateNorth;
                        }
                        if (requestParameters.coordinateSouth !== undefined) {
                            queryParameters['CoordinateSouth'] = requestParameters.coordinateSouth;
                        }
                        if (requestParameters.coordinateEast !== undefined) {
                            queryParameters['CoordinateEast'] = requestParameters.coordinateEast;
                        }
                        if (requestParameters.coordinateWest !== undefined) {
                            queryParameters['CoordinateWest'] = requestParameters.coordinateWest;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Buildings/floors",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return FloorPagedCollectionApiResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BuildingsApi.prototype.queryFloors = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryFloorsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BuildingsApi.prototype.queryRoomsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, _c, _d, response;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.sortColumn !== undefined) {
                            queryParameters['SortColumn'] = requestParameters.sortColumn;
                        }
                        if (requestParameters.sortDirection !== undefined) {
                            queryParameters['SortDirection'] = requestParameters.sortDirection;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['Skip'] = requestParameters.skip;
                        }
                        if (requestParameters.take !== undefined) {
                            queryParameters['Take'] = requestParameters.take;
                        }
                        if (requestParameters.fMRecordId !== undefined) {
                            queryParameters['FMRecordId'] = requestParameters.fMRecordId;
                        }
                        if (requestParameters.fMModId !== undefined) {
                            queryParameters['FMModId'] = requestParameters.fMModId;
                        }
                        if (requestParameters.roomId !== undefined) {
                            queryParameters['RoomId'] = requestParameters.roomId;
                        }
                        if (requestParameters.floorId !== undefined) {
                            queryParameters['FloorId'] = requestParameters.floorId;
                        }
                        if (requestParameters.buildingId !== undefined) {
                            queryParameters['BuildingId'] = requestParameters.buildingId;
                        }
                        if (requestParameters.propertyId !== undefined) {
                            queryParameters['PropertyId'] = requestParameters.propertyId;
                        }
                        if (requestParameters.buildingCode !== undefined) {
                            queryParameters['BuildingCode'] = requestParameters.buildingCode;
                        }
                        if (requestParameters.floorCode !== undefined) {
                            queryParameters['FloorCode'] = requestParameters.floorCode;
                        }
                        if (requestParameters.roomCode !== undefined) {
                            queryParameters['RoomCode'] = requestParameters.roomCode;
                        }
                        if (requestParameters.roomName !== undefined) {
                            queryParameters['RoomName'] = requestParameters.roomName;
                        }
                        if (requestParameters.roomDescription !== undefined) {
                            queryParameters['RoomDescription'] = requestParameters.roomDescription;
                        }
                        if (requestParameters.use !== undefined) {
                            queryParameters['Use'] = requestParameters.use;
                        }
                        if (requestParameters.category !== undefined) {
                            queryParameters['Category'] = requestParameters.category;
                        }
                        if (requestParameters.type !== undefined) {
                            queryParameters['Type'] = requestParameters.type;
                        }
                        if (requestParameters.vacancy !== undefined) {
                            queryParameters['Vacancy'] = requestParameters.vacancy;
                        }
                        if (requestParameters.department !== undefined) {
                            queryParameters['Department'] = requestParameters.department;
                        }
                        if (requestParameters.area !== undefined) {
                            queryParameters['Area'] = requestParameters.area;
                        }
                        if (requestParameters.gPS !== undefined) {
                            queryParameters['GPS'] = requestParameters.gPS;
                        }
                        if (requestParameters.roomBoundry !== undefined) {
                            queryParameters['RoomBoundry'] = requestParameters.roomBoundry;
                        }
                        if (requestParameters.buildingSpecialCode !== undefined) {
                            queryParameters['BuildingSpecialCode'] = requestParameters.buildingSpecialCode;
                        }
                        if (requestParameters.firstname !== undefined) {
                            queryParameters['Firstname'] = requestParameters.firstname;
                        }
                        if (requestParameters.lastname !== undefined) {
                            queryParameters['Lastname'] = requestParameters.lastname;
                        }
                        if (requestParameters.departmentID !== undefined) {
                            queryParameters['DepartmentID'] = requestParameters.departmentID;
                        }
                        if (requestParameters.cCompositeCode !== undefined) {
                            queryParameters['cCompositeCode'] = requestParameters.cCompositeCode;
                        }
                        if (requestParameters.cRoomCodeForSort !== undefined) {
                            queryParameters['cRoomCodeForSort'] = requestParameters.cRoomCodeForSort;
                        }
                        if (requestParameters.uTILCLat !== undefined) {
                            queryParameters['UTIL__cLat'] = requestParameters.uTILCLat;
                        }
                        if (requestParameters.uTILCLong !== undefined) {
                            queryParameters['UTIL__cLong'] = requestParameters.uTILCLong;
                        }
                        if (requestParameters.uTILLatNEW !== undefined) {
                            queryParameters['UTIL__LatNEW'] = requestParameters.uTILLatNEW;
                        }
                        if (requestParameters.uTILLongNEW !== undefined) {
                            queryParameters['UTIL__LongNEW'] = requestParameters.uTILLongNEW;
                        }
                        if (requestParameters.uTILCNewGPS !== undefined) {
                            queryParameters['UTIL__cNewGPS'] = requestParameters.uTILCNewGPS;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 1:
                        // oauth required
                        _a[_b] = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 4];
                        // oauth required
                        _c = headerParameters;
                        _d = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("oauth2", ["pmo.api.full_access", "openid"])];
                    case 3:
                        // oauth required
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: return [4 /*yield*/, this.request({
                            path: "/api/Buildings/rooms",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 5:
                        response = _e.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return RoomPagedCollectionApiResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BuildingsApi.prototype.queryRooms = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryRoomsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return BuildingsApi;
}(runtime.BaseAPI));
export { BuildingsApi };
